<template>
  <div v-if="visible" class="alert alert-warning py-2 px-3 mb-0">
    {{ hintText }}
    <router-link :to="{name: 'packages.index', query: routeQuery}" class="alert-link">
      {{ ctaText }}
    </router-link>
  </div>
</template>

<script>
import {
  PREMIUM_EXTERNAL_LINKS_CTA,
  PREMIUM_EXTERNAL_LINKS_HINT,
} from '@/utils/objectFormPolicy'

export default {
  name: 'PremiumFeatureHint',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    routeQuery: {
      type: Object,
      default: () => ({}),
    },
    hintText: {
      type: String,
      default: PREMIUM_EXTERNAL_LINKS_HINT,
    },
    ctaText: {
      type: String,
      default: PREMIUM_EXTERNAL_LINKS_CTA,
    },
  },
}
</script>
